import { render, staticRenderFns } from "./assessment-result.view.vue?vue&type=template&id=06039d62&scoped=true&"
import script from "./assessment-result.view.vue?vue&type=script&lang=ts&"
export * from "./assessment-result.view.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-result.view.vue?vue&type=style&index=0&id=06039d62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06039d62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
